// src/locales/si/attributes.js
export const attributes = {

    // Page titles and descriptions
    title: "නිෂ්පාදන ගුණාංග",
    description: "වඩා හොඳ නිෂ්පාදන සංවිධානය සඳහා නිෂ්පාදන ගුණාංග සහ ඒවායේ අගයන් කළමනාකරණය කරන්න",
    
    // Navigation
    addAttribute: "ගුණාංගය එක් කරන්න",
    createNewAttribute: "නව ගුණාංගයක් සාදන්න",
    editAttribute: "ගුණාංගය සංස්කරණය කරන්න",
    createFirstAttribute: "පළමු ගුණාංගය සාදන්න",
    
    // Form Fields
    attributeName: "ගුණාංග නම",
    attributeNamePlaceholder: "ගුණාංග නම ඇතුළත් කරන්න (උදා: ප්‍රමාණය, වර්ණය, ද්‍රව්‍ය)",
    values: "අගයන්",
    valuePlaceholder: "අගය {{index}} ඇතුළත් කරන්න",
    addValue: "අගය එක් කරන්න",
    removeValue: "අගය ඉවත් කරන්න",
    valueCount: "අගයන්",
    
    // Table Headers
    filteredResults: "ගුණාංග {{total}} න් {{count}}",
    totalAttributes: "ගුණාංග {{count}}",
    searchAttributes: "නම හෝ අගයන් මගින් ගුණාංග සොයන්න...",
    
    // Validation Messages
    nameRequired: "ගුණාංග නම අවශ්‍යයි",
    nameMinLength: "ගුණාංග නම අවම වශයෙන් අක්ෂර 2ක් විය යුතුයි",
    valuesRequired: "අවම වශයෙන් එක් අගයක් අවශ්‍යයි",
    duplicateValues: "අනුපිටපත් අගයන්ට අවසර නැත",
    
    // Actions
    createAttribute: "ගුණාංගය සාදන්න",
    updateAttribute: "ගුණාංගය යාවත්කාලීන කරන්න",
    
    // Success/Error Messages
    attributeCreatedSuccess: "'{{attributeName}}' ගුණාංගය සාර්ථකව සාදන ලදී!",
    attributeUpdatedSuccess: "'{{attributeName}}' ගුණාංගය සාර්ථකව යාවත්කාලීන කරන ලදී!",
    attributeDeletedSuccess: "'{{attributeName}}' ගුණාංගය සාර්ථකව මකා දමා ඇත.",
    failedToCreate: "ගුණාංගය සෑදීමට අසමත් විය. කරුණාකර නැවත උත්සාහ කරන්න.",
    failedToUpdate: "ගුණාංගය යාවත්කාලීන කිරීමට අසමත් විය. කරුණාකර නැවත උත්සාහ කරන්න.",
    failedToDelete: "ගුණාංගය මකා දැමීමට අසමත් විය. කරුණාකර නැවත උත්සාහ කරන්න.",
    failedToLoadAttribute: "ගුණාංග විස්තර පූරණය කිරීමට අසමත් විය. කරුණාකර නැවත උත්සාහ කරන්න.",
    
    // Loading states
    loadingAttributes: "ගුණාංග පූරණය වෙමින්...",
    loadingAttributesDesc: "කරුණාකර අපි ඔබේ නිෂ්පාදන ගුණාංග ලබා ගන්නා තෙක් රැඳී සිටින්න.",
    
    // Empty states
    noAttributes: "තවම ගුණාංග නැත",
    noAttributesDesc: "විශේෂිත ලක්ෂණ අනුව ඔබේ නිෂ්පාදන සංවිධානය කිරීම ආරම්භ කිරීමට ඔබේ පළමු නිෂ්පාදන ගුණාංගය සාදන්න.",
    noSearchResults: "ගුණාංග හමු නොවීය",
    noSearchResultsDesc: "ඔබේ සෙවුම් පද සකස් කිරීමට උත්සාහ කරන්න හෝ සියලුම ගුණාංග බැලීමට පෙරහන් ඉවත් කරන්න.",
    
    // Confirmation dialogs
    confirmDelete: "ඔබට විශ්වාසද '{{attributeName}}' ගුණාංගය මකා දැමීමට? මෙම ක්‍රියාව අහෝසි කළ නොහැකි අතර මෙම ගුණාංගය භාවිතා කරන නිෂ්පාදන වලට බලපෑ හැකිය."
};